import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PrivateRoute from '../../components/Routes/PrivateRoute';

const mapStateToProps = ({ global: { auth } }) => ({
  featureAccessList: auth.featureAccessList,
  isAuthenticated: auth.isAuthenticated,
  isFetching: auth.isFetching || auth.isLoadingUser,
});

const PrivateRouteWithState = connect(
  mapStateToProps,
  null,
)(PrivateRoute);

export default withRouter(PrivateRouteWithState);
